import { ToastContainer } from "react-toastify";

type ToastProps = {
    theme?: "light" | "dark" | "colored";
    position?:
        | "top-right"
        | "top-center"
        | "top-left"
        | "bottom-right"
        | "bottom-center"
        | "bottom-left";
};

export function Toast({ theme = "colored", position = "top-center" }: ToastProps = {}) {
    return <ToastContainer theme={theme} position={position} />;
}
